import { defineStore } from "pinia";
import Vue, { ref } from "vue";
import axios from "axios";
import { POSITION, TYPE } from "vue-toastification";
import i18n from "@/i18n";
import { Source, SourceInfo } from "@/model/source";

export const useSourceStore = defineStore("source", () => {
  const source = ref<SourceInfo>({
    id: -1,
    molecules: [],
    title: "",
    author: "",
    publicationYear: "",
    synergies: [],
    type: "",
  });
  const sources = ref<Source[]>([]);
  const sourceTypes = ref<string[]>([]);

  const getSources = async () => {
    await axios
      .get<Source[]>("/source")
      .then((res) => (sources.value = res.data));
  };
  const getSourceById = async (id: number) => {
    await axios
      .get<SourceInfo>(`/source/${id}`)
      .then((res) => (source.value = res.data));
  };

  const getSourceTypes = async () => {
    await axios
      .get<string[]>("/source/sourcetypes")
      .then((res) => (sourceTypes.value = res.data));
  };
  const addSource = async () => {
    await axios
      .post<Source>("/source", source.value)
      .then((res) => {
        sources.value.push(res.data);
        Vue.$toast(i18n.t("source.toast.add.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("source.toast.add.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  const updateSource = async () => {
    await axios
      .patch<SourceInfo>(`/source/${source.value.id}`, source.value)
      .then(() => {
        Vue.$toast(i18n.t("source.toast.update.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("source.toast.update.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  const deleteSource = async (id) => {
    await axios
      .delete(`/source/${id}`)
      .then((res) => {
        const idx: number = sources.value.findIndex(
          (item) => item.id === res.data.id
        );
        sources.value.splice(idx, 1);
        Vue.$toast(i18n.t("source.toast.delete.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("source.toast.delete.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  return {
    source,
    sources,
    sourceTypes,
    getSources,
    getSourceById,
    getSourceTypes,
    addSource,
    updateSource,
    deleteSource,
  };
});
